<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-line-chart`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 6a1 1 0 011 1v31h35a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h2zm34.527 6.707l1.414 1.414a1 1 0 010 1.415L31.627 26.849a1 1 0 01-1.414 0L28.8 25.435l-.006-.006-5.65-5.65-10.607 10.606a1 1 0 01-1.415 0L9.707 28.97a1 1 0 010-1.415L21.013 16.25l.008-.007.802-.801.612-.614a.996.996 0 01.53-.277l.118-.014h.118c.236.014.468.111.648.291l1.415 1.415h.001l5.656 5.657 9.192-9.193a1 1 0 011.414 0z"/></svg>
</template>
<script>

export default {
  name: 'IconLineChart',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
